import RequestReportActionTypes from './gold-price-report.types';
import { docodeHexResponse } from '../../_common/common.utils';
const INITIAL_STATE = {
	fetchRequestReportDetailsResponse: null,
	fetchRequestReportDetailsArr: [],
};

const goldPriceReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** FETCH GOLD PRICE DETAILS START *********************** */
		case RequestReportActionTypes.GET_GOLD_UPDATE_LOG_REPORT_SUCCESS:
			return {
				...state,
				fetchRequestReportDetailsResponse: action.payload,
				fetchRequestReportDetailsArr: docodeHexResponse(
					action.payload,
					'FetchGoldPriceDetailsKey',
				),
			};

		case RequestReportActionTypes.GET_GOLD_UPDATE_LOG_REPORT_FAILURE:
			return { ...state, fetchRequestReportDetailsResponse: action.payload };

		case RequestReportActionTypes.GET_GOLD_UPDATE_LOG_REPORT_RESPONSE_CHANGED:
			return { ...state, fetchRequestReportDetailsResponse: null };

		/** ***************** FETCH GOLD PRICE DETAILS END *********************** */

		default:
			return state;
	}
};

export default goldPriceReducer;
